export type PlanInterval = 'year' | 'month' | 'day';

export enum IntervalTabs
{
  year = 1,
  month = 2,

}
export enum FilterTabs
{
  Recomendados = 1,
  Todos = 2,
}

export interface Pricing
{
  plans: Plan[];
  addons: Plan[];
}

export interface Plan
{
  ProductId: string;
  CreatedOn: string;
  Description: string;
  Name: string;
  Images: string[];
  Prices: Price[];
  TaxCode: null;
  Tax: Tax;
  Interval?: PlanInterval | null;
  checked?: boolean;
  Quantity?: number;
  Metadata: Metadata;
}

export interface Price
{
  Taxes: number;
  PriceId: string;
  Currency: string;
  ProductId: string;
  Recurring: Recurring;
  Type: null;
  UnitAmount: number;
  Unit: number;
  Interval: PlanInterval;
  IntervalCount: number;
  UsageType: string;
  Quantity?: number;
  Checked?: boolean;
  Name?: string;
  Metadata: Metadata;
  Order?: number;
}

export interface Recurring
{
  Inteval: null;
  IntervalCount: number;
  UsageType: null;
}

export interface Tax
{
  id: string;
  object: string;
  active: boolean;
  country: string;
  created: number;
  description: string;
  display_name: string;
  inclusive: boolean;
  jurisdiction: null;
  livemode: boolean;
  metadata: Record<string, never>;
  percentage: number;
  state: null;
  tax_type: null;
}

export interface Metadata
{
  icon: string;
}

export interface ProductsSubcription extends Pricing
{
  StatusSubscription: string;
}
